import React from 'react';
import {
  CellListContainer,
  CellListContent,
  CellListIcon,
  CellListText,
  CellListInlineItem,
  CellListCaret,
} from './CellListCSS';
import { isValidColor, lighten } from '../../Utils/colorManipulator';

export const CellList = ({
  value,
  color,
  icon,
  onClick,
  onMouseUp,
  unit = '',
  label,
  isStacked,
  asChip = true,
  grow = false,
  canWrite = false,
}) => {
  return (
    <CellListContainer
      onClick={onClick}
      onMouseUp={onMouseUp}
      $label={label}
      $isStacked={isStacked}
      $asChip={asChip}
      $grow={grow}
    >
      {' '}
      <CellListContent
        $isStacked={isStacked}
        $grow={grow}
        $bg={lighten(color, 0.9)}
      >
        <CellListIcon $color={color} $icon={icon} />
        <CellListText $grow={grow}>
          {value}
          {unit}
        </CellListText>
        {canWrite && <CellListCaret>▼</CellListCaret>}
      </CellListContent>
    </CellListContainer>
  );
};
